import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { RootState } from '../store';

export type ToolSliceType = {
  loginTip: boolean;
};

const initialState: ToolSliceType = {
  loginTip: false
};

const slice = createSlice({
  name: 'Tool',
  initialState,
  reducers: {
    setTipLogin(state: ToolSliceType, action: PayloadAction<boolean>) {
      state.loginTip = action.payload;
    }
  },
});

export const {
  setTipLogin
} = slice.actions;

export const selectTool = createSelector(
  [(state: RootState) => state.tool],
  (state) => state
);

export default slice.reducer;